import requests from './request';

// 二级分类请求
export const reqClassify = params => {
    return requests({
        url: `/classify/getListByParentId?pageNum=${params.pageNum}&pageSize=8&departmentId=${params.departmentId}`,
        method: 'get'
    });
};
export const reqClassifyLenght = pageNum => {
    return requests({ url: `/classify/getListByParentId?pageNum=${pageNum}&pageSize=99`, method: 'get' });
};
// 根据id查询二级分类 get请求带参用params
export const reqByClassifyId = params => {
    // var params = { classifyId: sid };
    // console.log(params);
    return requests({ url: '/transaction/queryByClassifyIdConfigList', method: 'get', params });
};
// 查询全部导办事物和办事指南
export const sumTransactionNum = () => {
    return requests({ url: '/transaction/sumTransactionNum', method: 'get' });
};
// 轮播图
export const slideShow = () => {
    return requests({ url: '/slideshow/selectList', method: 'get' });
};
// 获取办事部门
export const getOrganization = () => {
    return requests({ url: '/organization/getList', method: 'get' });
};

// 商家入驻
export const reqApply = data => {
    return requests({ url: '/mallorg/addMallorg', method: 'post', data });
};
// 获取商铺列表
export const selectDept = () => {
    return requests({ url: '/dept/selectConfigList', method: 'get' });
};
// 获取类型
export const selectType = () => {
    return requests({ url: '/malllabel/selectConfigList', method: 'get' });
};
// 获取用户
export const selectIsStore = (params) => {
    return requests({ url: '/mallorg/selectData', method: 'get', params });
};
// 注销机构
export const reqCancellationMechanism = data => {
    return requests({ url: '/mallorg/upDate', method: 'post', data });
};
// 获取隐私协议
export const getAgreement = () => {
    return requests({ url: '/sysprotocol/getAgreement', method: 'get' });
};
// 福利券列表
export const getMallBoonRoster = (e) => {
    return requests({ url: `/mallBoon/getMallBoonRoster?boonName=${e.boonName}&phone=${e.phone}&putaway=${e.putaway}&type=${e.type}`, method: 'get' })
};
// 福利券详情
export const getMallBoonById = (e) => {
    return requests({ url: `/mallBoon/getMallBoonById?id=${e}`, method: 'get' })
};
// 名单管理
export const getMallBoonRosterByVerificationState = (e) => {
    return requests({ url: `/mallboonroster/getMallBoonRosterByVerificationState?mallBoonID=${e.mallBoonID}&verificationState=${e.verificationState}`, method: 'get' })
};
// 添加花惠卡
export const addMallOrgDiscount = data => {
    return requests({ url: '/mallOrgDiscount/addMallOrgDiscount', method: 'post', data });
};
// 修改花惠卡
export const updateMallOrgDiscount = data => {
    return requests({ url: '/mallOrgDiscount/updateMallOrgDiscount', method: 'post', data });
};
// 查看花惠卡
export const getMallOrgDiscount = (e) => {
    return requests({ url: `/mallOrgDiscount/getMallOrgDiscount?audit=${e.audit}&phone=${e.phone}`, method: 'get' })
};
// 查看门店
export const getMallbranchstore = (e) => {
    return requests({ url: `/mallbranchstore/getMallbranchstore?audit=${e.audit}&phone=${e.phone}`, method: 'get' })
};
// 删除门店
export const deleteMallbranchstore = (e) => {
    return requests({ url: `/mallbranchstore/deleteMallbranchstore?id=${e.id}&phone=${e.phone}`, method: 'get' })
};
// 修改门点
export const updateMallbranchstore = data => {
    return requests({ url: '/mallbranchstore/updateMallbranchstore', method: 'post', data });
};
// 添加门店
export const addMallbranchstore = data => {
    return requests({ url: '/mallbranchstore/addMallbranchstore', method: 'post', data });
};